import React from "react";

import { Slider, SliderProps, css, styled } from "@mui/material";

import { skipForwardProp } from "@/utils/skipForwardProp";

type PropTypes = Omit<SliderProps, "onChange"> & {
  value?: number[];
  onChange?: (value: [number, number]) => void;
  sliderUnactive?: boolean;
};

const StyledRangeSlider = styled(Slider, {
  shouldForwardProp: skipForwardProp(["sliderUnactive"]),
})<{ sliderUnactive?: boolean }>(({ sliderUnactive, theme }) => {
  return sliderUnactive
    ? css`
        .MuiSlider-track {
          opacity: 0;
        }
        .MuiSlider-thumb {
          background-color: ${theme.palette.grey1[50]};
        }
      `
    : "";
});

export const RangeSlider: React.FC<PropTypes> = ({ onChange, ...props }) => {
  const handleChange: SliderProps["onChange"] = (_e, value) => {
    onChange && onChange(value as [number, number]);
  };

  return (
    <StyledRangeSlider
      onChange={handleChange}
      valueLabelDisplay="auto"
      {...props}
    />
  );
};
